<template>
  <LoaderFullscreen />
</template>

<script>
import api from '@/api';
import { LoaderFullscreen } from '@/components/common';

export default {
  name: 'Checkout',
  components: { LoaderFullscreen },
  async created() {
    try {
      const sessionId = await api.subscription.create();
      const stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY);
      await stripe.redirectToCheckout({ sessionId });
    } catch (error) {
      console.log(error);
      this.$notifications.error(error.message);
    }
  },
};
</script>

<style>

</style>
